import { Controller } from "@hotwired/stimulus"

// 所属する Turbo Frame を一定間隔で再読込する汎用ポーリング。
// バックグラウンドジョブの完了待ちプレースホルダに付与し、
// 完了後のレスポンス（このコントローラーを含まない）に差し替わると自動停止する。
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 4000 },
    timeout: { type: Number, default: 360000 },
  }

  connect() {
    this.timer = setInterval(() => this.refresh(), this.intervalValue)
    this.deadline = setTimeout(() => this.stop(), this.timeoutValue)
  }

  disconnect() {
    this.stop()
  }

  stop() {
    if (this.timer) clearInterval(this.timer)
    if (this.deadline) clearTimeout(this.deadline)
    this.timer = null
    this.deadline = null
  }

  refresh() {
    const frame = this.element.closest("turbo-frame")
    if (!frame) return this.stop()

    // regenerate 付き URL のまま reload すると毎回再enqueueされるため、
    // ポーリングは必ず url value（素の caption URL）へ向ける
    const target = new URL(this.urlValue, window.location.origin).href
    if (frame.src === target) {
      frame.reload()
    } else {
      frame.src = target
    }
  }
}
